import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row",
        position: "relative",
        flexShrink: 0
    }
});

export const useStyles = ({
    shapeConfigs,
    spaces
}: {
    spaces: NCoreUIKit.ActivePalette["spaces"];
    shapeConfigs: NCoreUIKit.ShapeConfigs;
}) => {
    const styles = {
        container: {
            zIndex: shapeConfigs.layers.raised + 1,
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
